import fetch from '@/config/fetch'

export const editOrderDepositPrice = data => fetch('/editOrderDepositPrice.aspx',data, 'POST');

export const getListCustomer = data => fetch('getListCustomer.aspx',data, 'POST');

export const getListCustomerYN = data => fetch('getListCustomerYN.aspx',data, 'POST');

export const getBuyInfo = data => fetch('getBuyInfo.aspx',data, 'POST');

export const addShopBuyInfo = data => fetch('addShopBuyInfo.aspx',data, 'POST');

export const getlistShopBuyInfo = data => fetch('getlistShopBuyInfo.aspx',data, 'POST');

export const getListManageLogin = data => fetch('getListManageLogin.aspx',data, 'POST');

export const addManageLogin= data => fetch('addManageLogin.aspx',data, 'POST');

export const editManageLogin= data => fetch('editManageLogin.aspx',data, 'POST');

export const editManageLoginIsdisable= data => fetch('editManageLoginIsdisable.aspx',data, 'POST');

export const editManageLoginmoney= data => fetch('editManageLoginmoney.aspx',data, 'POST');

export const editManageLoginPwd= data => fetch('editManageLoginPwd.aspx',data, 'POST');

export const delManageLogin= data => fetch('delManageLogin.aspx',data, 'POST');

export const editLoginPwd= data => fetch('editLoginPwd.aspx',data, 'POST');



export const getLoginToken= data => fetch('getLoginToken.aspx',data, 'POST');

export const getListStores= data => fetch('getListStores.aspx',data, 'POST');

export const uploadImg = data => fetch('upload_images.aspx',data, 'POST');

export const getListProvince = data => fetch('getListProvince.aspx',data, 'POST');

export const getListCity = data => fetch('getListCity.aspx',data, 'POST');

export const getListDistrict = data => fetch('getListDistrict.aspx',data, 'POST');





// WEBPACK FOOTER //
// ./src/api/getData.js